const list = (state) => {
  return state.list
}
export default {
  list
}



// WEBPACK FOOTER //
// ./src/features/vp/curriculo/minhasAnotacoes/store/getters.js